const carriers: Record<string, { url: string; appendInvoice: boolean }> = {
  대한통운: { url: 'https://www.cjlogistics.com/ko/tool/parcel/newTracking?gnbInvcNo=', appendInvoice: true },
  CJ대한통운: { url: 'https://www.cjlogistics.com/ko/tool/parcel/newTracking?gnbInvcNo=', appendInvoice: true },
  한진택배: { url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038', appendInvoice: false },
  우체국택배: { url: 'https://service.epost.go.kr/iservice/usr/trace/usrtrc001k01.jsp', appendInvoice: false },
  롯데택배: { url: 'https://www.lotteglogis.com/home/reservation/tracking/index', appendInvoice: false },
  로젠택배: { url: 'https://www.ilogen.com/web/personal/tkSearch?t=1', appendInvoice: false },
};
const aliases: Record<string, string> = {
  CJ: 'CJ대한통운', 한진: '한진택배', 우체국: '우체국택배', 롯데: '롯데택배', 로젠: '로젠택배',
};

export function carrierTrackingLink(courier: string, invoice: string) {
  const name = courier.replace(/\s/g, '').toUpperCase();
  const entry = carriers[aliases[name] || name];
  if (!entry || !invoice.trim()) return null;
  return { url: entry.appendInvoice ? entry.url + encodeURIComponent(invoice.trim()) : entry.url,
    needsInvoicePaste: !entry.appendInvoice };
}
